module.exports = "https://static.wanderu.com/ui-react/_next/static/media/nl.8b5197ab.svg";